import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import NavbarContainer from "./Container/Navigate/NavbarContainer";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import RecipeDetail from "./pages/RecipeDetail";
import UserInfo from "./components/ProfileComponent/UserInfo";
import Account from "./components/ProfileComponent/Account";
import RecipeManagement from "./components/ProfileComponent/RecipeManagement";
import ExchangeHistory from "./components/ProfileComponent/ExchangeHistory";
import { useSelector } from "react-redux";
import Loading from "./components/Loading";
import { Toaster } from "react-hot-toast";
import Notification from "./pages/Notification";
import CreateRecipe from "./pages/CreateRecipe";
import ModalLoginContainer from "./Container/Auth/ModalLoginContainer";
import logo from "./imgs/foodrecipe-logo.png";

const App = () => {

   const settings = useSelector(state => state.settings.settings);

   useEffect(() => {
      const root = document.documentElement
      for (let key in settings) {
         root.style.setProperty(key, settings[key]);
      }
   }, [settings])

   return (
      <Router>
         <ScrollToTop />
         <NavbarContainer />
         <div className="container main">
            <Routes>
               {/* <Route path="/" element={<HomeComponent />} /> */}
               <Route path="/" element={<Home />} />
               <Route path="/profile" element={<Profile />}>
                  <Route path="information" element={<UserInfo />} />
                  <Route path="account" element={<Account />} />
                  <Route path="recipes" element={<RecipeManagement />} />
                  <Route path="exchange-history" element={<ExchangeHistory />} />
               </Route>
               <Route path="/create-recipe" element={<CreateRecipe />} />
               <Route path="/settings" element={<Settings />} />
               <Route path="/auth">
                  <Route path="sign-in" element={<SignIn />} />
                  <Route path="sign-up" element={<SignUp />} />
               </Route>
               <Route path="recipe/:id" element={<RecipeDetail />} />
               <Route path="/notifications" element={<Notification />} />
            </Routes>
         </div>
         <Footer />
         <Toaster position="top center" />
         <ModalLoginContainer />
         <Loading />
         <div className="background_image_left">
            <img src={logo} alt="" />
         </div>
         <div className="background_image_right">
            <img src={logo} alt="" />
         </div>
      </Router>
   );
};

export default App;

function ScrollToTop() {
   const location = useLocation();
   useEffect(() => {
      window.scrollTo(0, 0);
   }, [location]);

   return null;
}
